import React, { useMemo, useEffect } from 'react'
import { Form, Button, Input, Row, Col, Popconfirm, InputNumber, Select } from 'antd'
import SubItems from './SubItems'
import './style.less'
import { CloseCircleOutlined } from '@ant-design/icons'
import { ComplianceType, QcType } from '../../constants'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'

const initialValue = {
  'name': '',
  'type': QcType.compliance,
  'items': [
    {
      'name': '',
      'moduleName': '合规质检',
      'description': '',
      'subItems': [
        {
          'complianceType': ComplianceType.violation,
          'description': '',
        },
      ],
    },
  ],
}

const CreateEditCompliance = ({ qcId, qcPlanDetail, onSave }: { qcId: number | null, qcPlanDetail: AIQualityCheckPlanDetailItem | null, onSave: (data: AIQualityCheckPlanDetailItem) => void }) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (qcId && qcPlanDetail) {
      form.setFieldsValue(qcPlanDetail)
    }
  }, [qcId, qcPlanDetail])

  const onFinish = (values) => {
    onSave(values)
  }

  return (
    <div className="scheme-create-compliance-form-container">
      <Form form={form}
        initialValues={initialValue}
        onFinish={onFinish}>
        <Form.Item hidden label="方案ID" name="id">
          <Input />
        </Form.Item>
        <Form.Item label="方案类型" name="type" className="compliance-form-primary-item">
          <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff' }}>
            #违规判断
          </Button>
        </Form.Item>
        <Row style={{ width: '100%' }}>
          <Col span={12}>
            <Form.Item label="方案名称" name="name" rules={[{ required: true, message: '请输入方案名称' }]} className="compliance-form-primary-item">
              <Input maxLength={30} placeholder="请输入方案名称" />
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.List name="items">
              {(fields, { add }) => (
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => add({
                      'name': '',
                      'moduleName': '合规质检',
                      'description': '',
                      'subItems': [
                        {
                          'complianceType': ComplianceType.violation,
                          'description': '',
                        },
                      ],
                    })}
                    style={{ marginLeft: 8 }}
                  >
                    新建规则
                  </Button>
                </Form.Item>
              )}
            </Form.List>
          </Col>
        </Row>
        <Form.List name="items">
          {(fields, { remove: removeInner }) => (
            <>
              {fields.map((field, index) => (
                <div key={field.key}>
                  <div className="compliance-form-item" key={field.key}>
                    <Form.Item
                      hidden
                      name={[field.name, 'moduleName']}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      className="compliance-form-primary-item"
                      label={`规则${index + 1}`}
                      name={[field.name, 'name']}
                      rules={[{ required: true, message: '请输入规则名称' }]}
                    >
                      <Input.TextArea maxLength={500} placeholder="请输入规则描述，即不允许对话主体出现的行为/需要严格核查的行为，描述需要清晰且具体，也要避免各规则之间出现重叠，如果有相关的高危关键词，也可以一并列出" autoSize={{ minRows: 1, maxRows: 2 }} />
                    </Form.Item>
                    <Form.Item style={{ width: 50, textAlign: 'right' }}>
                      {
                        fields.length > 1 && (
                          <Popconfirm title="确认需要删除规则吗？" onConfirm={() => removeInner(field.name)}>
                            <Button
                              type="link"
                            >
                              删除
                            </Button>
                          </Popconfirm>
                        )
                      }
                    </Form.Item>
                  </div>
                  <SubItems field={field} form={form} />
                </div>
              ))}
            </>
          )}
        </Form.List>
        <Form.Item style={{ display: 'flex', justifyContent: 'center' }}>
          <Button type="primary" htmlType="submit">
            保存方案
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default CreateEditCompliance
